import {useMemo} from 'react'

import {useAutoAssignAgentEnabled} from '../features/auto-assign-agent/use-auto-assign-agent-enabled'
import {
  AutoAssignAgentColumnWorkflowDefinition,
  type ColumnWorkflowDefinition,
  getColumnWorkflowStatesByFieldOptionId,
} from '../helpers/workflow-utilities'
import {useWorkflows} from '../state-providers/workflows/use-workflows'

export function useColumnWorkflowStatesByFieldOptionId(fieldId?: number) {
  const autoAssignAgentEnabled = useAutoAssignAgentEnabled()
  const {workflows} = useWorkflows()

  const columnWorkflowDefinitions = useMemo<Array<ColumnWorkflowDefinition>>(() => {
    const definitions: Array<ColumnWorkflowDefinition> = []

    if (autoAssignAgentEnabled) definitions.push(AutoAssignAgentColumnWorkflowDefinition)

    return definitions
  }, [autoAssignAgentEnabled])

  return useMemo(
    () => getColumnWorkflowStatesByFieldOptionId(workflows, fieldId, columnWorkflowDefinitions),
    [columnWorkflowDefinitions, fieldId, workflows],
  )
}
